import invert from "lodash/invert";
import mapValues from "lodash/mapValues";
import { DEFAULT_LOCALE_BY_LANGUAGE } from "./DEFAULT_LOCALE";
import { getTwoLetterLanguageCode } from "./THREE_TO_TWO_LETTER_LANGUAGE_CODE";
var LANGUAGE_TO_COUNTRY = mapValues(DEFAULT_LOCALE_BY_LANGUAGE, function(locale) {
    return locale.country;
});
var COUNTRY_TO_LANGUAGE = invert(LANGUAGE_TO_COUNTRY);
var THREE_LETTER_COUNTRY_TO_DEFAULT_TWO_LETTER_LANGUAGE = mapValues(COUNTRY_TO_LANGUAGE, function(language) {
    return getTwoLetterLanguageCode(language);
});
export function getDefaultTwoLetterLanguageFromCountry(key) {
    return THREE_LETTER_COUNTRY_TO_DEFAULT_TWO_LETTER_LANGUAGE[key];
}
